import * as actionTypes from '../constant/event'
import {apiCall} from '../../service/apiCall'
import {setLoading} from './general'
import {get} from 'lodash'
import { URL, USER,PASS } from '../../service/base_url'
export const getEvent=(slug='')=>async dispatch=>{
    dispatch(setLoading(true))
    let dataReq={
        url:`/event/intro/0/1`,
        method:'GET',
        data:{
            auth:{username:USER,password:PASS}
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')==200){
        dispatch(setLoading(false))
        dispatch({
            type:actionTypes.GET_EVENT_ALL,
            payload:res.data
        })
        return res
    }else{
        dispatch(setLoading(false))

       
    }
}
export const getPublicWorkshop=(slug='/0/0/0')=>async dispatch=>{
    dispatch(setLoading(true))
    let dataReq={
        url:`/event/public${slug}`,
        method:'GET',
        data:{
            auth:{username:USER,password:PASS}
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')==200){
        dispatch(setLoading(false))
        let public_workshop=[]
        

        res.data.map((data)=>{
        let workshop=[]
           
            data.items.map((item)=>{
                let dumm=[
                    {id:1,dates:[]},
                    {id:2,dates:[]},
                    {id:3,dates:[]},
                    {id:4,dates:[]},
                    {id:5,dates:[]},
                    {id:6,dates:[]},
                    {id:7,dates:[]},
                    {id:8,dates:[]},
                    {id:9,dates:[]},
                    {id:10,dates:[]},
                    {id:11,dates:[]},
                    {id:12,dates:[]},
                ]
                item.dates.map((a)=>{
                    // console.log('ahihi', a,item.title)
                    let asdf=[]
                    asdf.push(a[0])
                    dumm[a[0].id-1].dates=asdf
                })
                workshop.push({title:item.title,id:item.workshopId,dates:dumm})
            })
            public_workshop.push({
                branch:data.branch,
                item:workshop
                
            })
        })

        console.log('res.data', public_workshop)
        let for_mobile=[]
        res.data.map((data,i)=>{
            let workshop_mobile=[]
            data.items.map((date,i)=>{
                workshop_mobile.push({title:date.title,dates:date.dates,workshopId:date.workshopId})
            })
            for_mobile.push({
                branch:data.branch,
                item:workshop_mobile
                
            })
        })
        console.log('res.data2', for_mobile)

        dispatch({
            type:actionTypes.GET_PUBLIC_WORKSHOP,
            payload:public_workshop
        })
        dispatch({
            type:actionTypes.GET_PUBLIC_WORKSHOP_MOBILE,
            payload:for_mobile
        })
        
    }else{
        dispatch(setLoading(false))

       
    }
}
export const getEventDetail=(id)=>async dispatch=>{
    dispatch(setLoading(true))
    let dataReq={
        url:`/event/${id}`,
        method:'GET',
        data:{
            auth:{username:USER,password:PASS}
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')==200){
        dispatch(setLoading(false))
        dispatch({
            type:actionTypes.GET_EVENT_DETAIL,
            payload:res.data
        })
        
    }else{
        dispatch(setLoading(false))
    }
}
export const getImageEventList=(id)=>async dispatch=>{
    dispatch(setLoading(true))
    let dataReq={
        url:`/event/eventimages/${id}/1`,
        method:'GET',
        data:{
            auth:{username:USER,password:PASS}
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')==200){
        dispatch(setLoading(false))
        dispatch({
            type:actionTypes.GET_EVENT_IMAGE,
            payload:res.data
        })
        
    }else{
        dispatch(setLoading(false))

    }
}